import React from "react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { Icon } from "../Icon";
import { WHY } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const WhyJorviko = () => {
  const { t } = useLang();
  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading overline={t(WHY.overline)} title={t(WHY.title)} />
        <div className="mt-16 grid gap-x-12 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {WHY.items.map((item, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <div data-testid={`why-${i}`} className="group border-t border-white/10 pt-6">
                <div className="flex items-center gap-3">
                  <Icon name={item.icon} className="h-5 w-5 text-[#60A5FA] transition-transform duration-500 group-hover:scale-110" />
                  <span className="font-mono text-xs text-white/30">0{i + 1}</span>
                </div>
                <h3 className="mt-5 text-xl font-medium tracking-tight text-white">{t(item.title)}</h3>
                <p className="mt-3 text-white/50 leading-relaxed">{t(item.desc)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
